import { DocumentoEnvioSimpleState } from './documento-envio-simple';
import { FirmanteRosterItem } from './firmante-roster-item';
import {
  AjustesEnvioSimple,
  CanalesEnvioSimple,
  FirmanteEnvioSimple,
  MensajeCorreoEnvioSimple
} from './firmante-envio-simple';

/** Estado exportado por `EnvioSimpleFlowService.exportarEstadoFlujo()`. */
export interface EnvioSimpleEstadoFlujoSalida {
  tipoEnvio: string | null;
  firmantesRoster: FirmanteRosterItem[];
  firmantesEnvio: FirmanteEnvioSimple[];
  mensajeCorreo: MensajeCorreoEnvioSimple;
  ajustesEnvio: AjustesEnvioSimple;
  canales: CanalesEnvioSimple;
  documentos: DocumentoEnvioSimpleState[];
}

/** Request POST `api/Envios/ProcesaEnvioSimple` (contrato backend dedicado). */
export interface ProcesaEnvioSimpleRequest {
  VersionContrato: string;
  Wait: boolean;
  IsEnvioTest: boolean;
  Documentos: ProcesaEnvioSimpleDocumentoRequest[];
  Firmantes: ProcesaEnvioSimpleFirmanteRequest[];
  Canales: ProcesaEnvioSimpleCanalesRequest;
  Mensaje: ProcesaEnvioSimpleMensajeRequest;
  Ajustes: ProcesaEnvioSimpleAjustesRequest;
  Metadata: ProcesaEnvioSimpleMetadataRequest;
}

export interface ProcesaEnvioSimpleDocumentoRequest {
  Id: string;
  Nombre: string;
  Orden: number;
  Origen: string;
  IdFicheroTemporal: string | null;
  IdTipoDocumento: number | string | null;
  Configuracion: Record<string, unknown>;
}

export interface ProcesaEnvioSimpleFirmanteRequest {
  Codigo: string;
  Desc: string;
  Orden: number;
  EsPrincipal: boolean;
  EsValidador: boolean;
  Nombre: string;
  Apellido1: string;
  Apellido2: string;
  Email: string;
  Telefono: string;
  CodigoEmpleado: string | null;
  DatosEmpleado: ProcesaEnvioSimpleDatosEmpleadoRequest | null;
}

/**
 * Ficha de empleado en `Firmantes[].DatosEmpleado` (paridad EmpleadoCrud, PascalCase).
 * Regla: null si el firmante no tiene snapshot `datosEmpleado` (solo inline);
 * objeto completo si el snapshot existe (lupa o panel lateral).
 */
export interface ProcesaEnvioSimpleDatosEmpleadoRequest {
  CodigoEmpleado: string;
  TipoDocumento: string;
  Nif: string;
  FechaNacimiento: string;
  Nombre: string;
  Apellido1: string;
  Apellido2: string;
  Nacionalidad: string;
  LugarNacimiento: string;
  EstadoCivil: string;
  Sexo: string;
  TipoPersona: string;
  Sigla: string;
  Provincia: string;
  Municipio: string;
  CodigoPostal: string;
  Numero: string;
  Escalera: string;
  Piso: string;
  Puerta: string;
  /** Compat contrato 1.0 (mailPersonal). */
  EmailPersonal: string;
  ExtensionTelefonoPersonal: string;
  TelefonoPersonal: string;
  /** Compat contrato 1.0 (mailProfesional). */
  EmailProfesional: string;
  ExtensionTelefonoProfesional: string;
  TelefonoProfesional: string;
  FechaAlta: string;
  PuestoTrabajo: string;
  Categoria: string;
  Convenio: string;
  CodigoEmpresa: string;
  CodigoCentro: string;
  EmpresaCif: string;
  NombreEmpresa: string;
  NombreCentro: string;
  CodigoExterno: string;
}

export interface ProcesaEnvioSimpleCanalesRequest {
  EnvioMail: boolean;
  EnvioSMS: boolean;
}

export interface ProcesaEnvioSimpleMensajeRequest {
  Subject: string;
  Body: string;
}

export interface ProcesaEnvioSimpleAjustesRequest {
  Recordatorio: boolean;
  Recordatorios: number[];
  Caducidad: number;
  EnvioParalelo: boolean;
}

export interface ProcesaEnvioSimpleMetadataRequest {
  TipoEnvioSeleccionado: string;
  FechaSolicitudCliente: string;
}

export interface OpcionesMapProcesaEnvioSimpleSalida {
  wait?: boolean;
  isEnvioTest?: boolean;
  versionContrato?: string;
  fechaSolicitudCliente?: string;
}

import { ResponseSubidaFicheros } from 'src/app/pages/subidaPrincipal/models/response-subida-ficheros';

export const VERSION_CONTRATO_PROCESA_ENVIO_SIMPLE = '1.0';

/** Respuesta estandar `SQPFirmaWebApiResponse` de `ProcesaEnvioSimple`. */
export interface ProcesaEnvioSimpleApiResponse {
  Ok: boolean;
  Data?: ProcesaEnvioSimpleResultadoApi;
  ExceptionMessage?: string;
  mensajeError?: string;
}

export interface ProcesaEnvioSimpleResultadoApi {
  mensaje?: string;
  Mensaje?: string;
  mensajePrincipal?: string;
  MensajePrincipal?: string;
  estadoGlobal?: string;
  EstadoGlobal?: string;
  finalizado?: boolean;
  Finalizado?: boolean;
  log?: ResponseSubidaFicheros;
  Log?: ResponseSubidaFicheros;
  firmantes?: ProcesaEnvioSimpleFirmanteResultadoApi[];
  Firmantes?: ProcesaEnvioSimpleFirmanteResultadoApi[];
  documentos?: ProcesaEnvioSimpleDocumentoResultadoApi[];
  Documentos?: ProcesaEnvioSimpleDocumentoResultadoApi[];
  errores?: ProcesaEnvioSimpleErrorApi[];
  Errores?: ProcesaEnvioSimpleErrorApi[];
}

export interface ProcesaEnvioSimpleDocumentoResultadoApi {
  Id?: string;
  id?: string;
  Estado?: string;
  estado?: string;
  MensajeEstado?: string;
  mensajeEstado?: string;
}

export type ProcesaEnvioSimpleErrorApi = string | {
  Mensaje?: string;
  mensaje?: string;
  Message?: string;
  message?: string;
};

export interface ProcesaEnvioSimpleFirmanteResultadoApi {
  Codigo?: string;
  codigo?: string;
  Orden?: number;
  orden?: number;
  Nombre?: string;
  nombre?: string;
  Apellido1?: string;
  apellido1?: string;
  Apellido2?: string;
  apellido2?: string;
  Email?: string;
  email?: string;
  Telefono?: string;
  telefono?: string;
  Estado?: string;
  estado?: string;
  EstadoEnvio?: string;
  estadoEnvio?: string;
  Mensaje?: string;
  mensaje?: string;
  MensajeEstado?: string;
  mensajeEstado?: string;
}
